import { useMetricTemplates as _useMetricTemplates } from '@griply/hooks';
import { useRemoteAppConfigQuery } from 'shared/hooks/queries/use-remote-app-config-query';

export const useMetricTemplates = () => {
  const { data } = useRemoteAppConfigQuery();

  return _useMetricTemplates(data);
};
